export enum BluechatNoteFooterField {
  SENDER_GLID = 'SENDER_GLID',
  RECEIVER_GLID = 'RECEIVER_GLID',
  DELIVERY_DATE = 'DELIVERY_DATE',
  DESTINATION_COUNTRY = 'DESTINATION_COUNTRY',
  LOAD_GROUP = 'LOAD_GROUP',
  ORIGIN_COUNTRY_CODE = 'ORIGIN_COUNTRY_CODE',
  DESTINATION_COUNTRY_CODE = 'DESTINATION_COUNTRY_CODE',
  ORIGIN_STATE_CODE = 'ORIGIN_STATE_CODE',
  DESTINATION_STATE_CODE = 'DESTINATION_STATE_CODE',
  DELIVERY_TYPE = 'DELIVERY_TYPE',
  CARRIER_NAME = 'CARRIER_NAME',
  LINK = 'LINK',
  RATE = 'RATE',
  PRODUCT_TYPE = 'PRODUCT_TYPE'
}
